export const SITE_URL = 'https://jonnystowingbc.ca';
export const ORGANIZATION_ID = `${SITE_URL}/#organization`;
export const WEBSITE_ID = `${SITE_URL}/#website`;

export const ORGANIZATION_SCHEMA = {
  '@type': 'Organization',
  '@id': ORGANIZATION_ID,
  name: "Jonny's Towing & Recovery Ltd.",
  alternateName: "Jonny's Towing",
  url: SITE_URL,
  logo: `${SITE_URL}/j-hook.svg`,
  image: [
    `${SITE_URL}/images/rolls-royce-flatbed.webp`,
    `${SITE_URL}/images/halloween-truck.webp`,
    `${SITE_URL}/images/christmas-truck.webp`,
  ],
  telephone: '+1-604-398-8866',
  email: 'dispatch@jonnystowingbc.ca',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Richmond',
    addressRegion: 'BC',
    addressCountry: 'CA',
  },
  areaServed: [
    { '@type': 'City', name: 'Richmond, British Columbia' },
    { '@type': 'AdministrativeArea', name: 'Greater Vancouver, British Columbia' },
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+1-604-398-8866',
    contactType: 'roadside assistance and towing dispatch',
    areaServed: 'CA-BC',
    availableLanguage: ['English'],
  },
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Towing and roadside assistance services',
    itemListElement: [
      'Flatbed towing',
      'Local towing',
      'Vehicle recovery and winching',
      'Lockout assistance',
      'Jump starts',
      'Spare tire changes',
      'Emergency fuel delivery',
      'Specialty transport',
    ].map((name) => ({
      '@type': 'Offer',
      itemOffered: { '@type': 'Service', name },
    })),
  },
};

export const WEBSITE_SCHEMA = {
  '@type': 'WebSite',
  '@id': WEBSITE_ID,
  url: SITE_URL,
  name: "Jonny's Towing & Recovery",
  publisher: { '@id': ORGANIZATION_ID },
  inLanguage: 'en-CA',
};

export function breadcrumbSchema(items) {
  return {
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  };
}
